import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertOnboarding } from "./ExpertOnboardingHook";
// Set the default state values for each context
const ExpertOnboardingContext = /*#__PURE__*/createContext({});
export const ExpertOnboardingContextProvider = ({
  children
}) => {
  const onboardingManager = useExpertOnboarding();
  const onboarding = useMemo(() => ({
    ...onboardingManager
  }), [onboardingManager]);
  return /*#__PURE__*/React.createElement(ExpertOnboardingContext.Provider, {
    value: onboarding
  }, children);
};
export const useExpertOnboardingContext = () => {
  return useContext(ExpertOnboardingContext);
};
ExpertOnboardingContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};